const LIMITE_TAMANHO_EXPANDIDA = 6
const INDICE_PRIMEIRO_ELEMENTO_ACCORDION = LIMITE_TAMANHO_EXPANDIDA - 1

export default <T>(listaCompleta: T[]) => {
  const totalElementos = listaCompleta?.length
  const listaExpandida: T[] = []
  const listaAccordion: T[] = []

  totalElementos > LIMITE_TAMANHO_EXPANDIDA &&
    listaAccordion.push(...listaCompleta.splice(INDICE_PRIMEIRO_ELEMENTO_ACCORDION, totalElementos - 1))
  listaExpandida.push(...listaCompleta)

  return { listaExpandida, listaAccordion }
}
